export type CameraRecordingStatus = 'on' | 'off';

export enum AnntType {
  ANNT_LINE_CROSS_NS = 101,
  ANNT_OBJECT_TRACKING_NS = 102,
  ANNT_INTRUSION_DETECT_NS = 103,
  ANNT_LOITERING_NS = 104,
  ANNT_TAMPERING_NS = 105,
}

export interface AnntRequest {
  namespace: AnntType;
  in_name: string;
  out_name: string;
  start_timestamp: string;
  end_timestamp: string;
  device_id: string;
}

export const FLASH_DURATION = 1000;

export type FeatureStatus = {
  enable: boolean;
  active: boolean;
};

export type CameraStatus = {
  id: string;
  status?: {
    recordingStatus: CameraRecordingStatus;
  };

  analytics?: {
    lineCrossing: {
      in: number;
      out: number;
      delta: number;
      counting: FeatureStatus & {
        eventIds: string[];
        isInitialized: boolean;
      };
      crossing: FeatureStatus & {
        eventIds: string[];
      };
    };
    intrusion: FeatureStatus;
    loitering: FeatureStatus;
    tampering: FeatureStatus;
  };
};
